import React from 'react'

export const AdsManagerIconWhite = ({ size = 57, className }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 57 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M38.3515 42.5833H9.33301C7.67616 42.5833 6.33301 41.2402 6.33301 39.5833V11.75C6.33301 10.0931 7.67615 8.75 9.33301 8.75H47.6663C49.3232 8.75 50.6663 10.0931 50.6663 11.75V30.6197"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.5 34.9993V25.666M25 34.9993V25.666M14.5 25.666V20.416C14.5 17.5165 16.8505 15.166 19.75 15.166V15.166C22.6495 15.166 25 17.5165 25 20.416V25.666M14.5 25.666H25"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M32 15.166V34.9993H38.5C40.7091 34.9993 42.5 33.2085 42.5 30.9993V19.166C42.5 16.9569 40.7091 15.166 38.5 15.166H32Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M48.4835 47.1254C48.2761 47.6454 47.5458 47.6612 47.3161 47.1506L41.7589 34.7966C41.5272 34.2814 42.034 33.7431 42.5622 33.9436L55.7425 38.9453C56.2707 39.1458 56.2929 39.8848 55.7777 40.1165L52.1894 41.7306L55.6131 45.0793C55.8593 45.3201 55.8684 45.7133 55.6335 45.9652L54.4795 47.2026C54.2369 47.4628 53.8278 47.4725 53.5731 47.2241L49.8801 43.6235L48.4835 47.1254Z"
            fill="white"
        />
    </svg>
)
